import { render, staticRenderFns } from "./PShortcuts.vue?vue&type=template&id=3e0b2256&"
import script from "./PShortcuts.vue?vue&type=script&lang=js&"
export * from "./PShortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports